import { render } from "./PpmSmetaChangeDialog.vue?vue&type=template&id=a0ffa478&scoped=true"
import script from "./PpmSmetaChangeDialog.vue?vue&type=script&lang=js"
export * from "./PpmSmetaChangeDialog.vue?vue&type=script&lang=js"

import "./PpmSmetaChangeDialog.vue?vue&type=style&index=0&id=a0ffa478&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0ffa478"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QIcon,QSpace,QBtn,QChip,QCardActions});qInstall(script, 'directives', {ClosePopup});
